<div class="top-m8" *transloco="let t; read: 'term-and-policy-pages.privacy-policy'">

    <!-- HEADER -->
    <div class="form-menu-container">
        <ng-container [ngTemplateOutlet]="stickyHeader"></ng-container>
    </div>

    <div class="form-menu-container sticky" *ngIf="isSticky()">
        <ng-container [ngTemplateOutlet]="stickyHeader"></ng-container>
    </div>

    <ng-template #stickyHeader>
        <div class="form-menu">
            <div class="form-menu-actions">
                <button type="submit" class="btn btn-primary" (click)="goToHome()">
                    <i class="fa fa-arrow-left"></i>&nbsp;
                        {{ t('back') }}
                    <i class="fa fa-home"></i>&nbsp;
                </button>
            </div>
            <div class="form-menu-info">
                <i class="fa fa-user"></i>&nbsp;
                {{ t('header-title') }}
            </div>
            <div class="span"></div>
        </div>
    </ng-template>

    <ngx-extended-pdf-viewer
        class="embedded"
        [src]="'assets/privacy_declaration/PRIVACY_DECLARATION_' + (lang$ | async) + '.pdf'"
        [showToolbar]="false"
        [showBorders]="false"
        [zoom]="'auto'"
    ></ngx-extended-pdf-viewer>

</div>
